/**
 * Default backend base URL used when `VITE_API_URL` is not set at build
 * time. Prod builds on Cloudflare Pages bake `VITE_API_URL` from the env;
 * this constant is the single source of truth for the fallback.
 *
 * To point the iframe at a different backend (staging, per-operator,
 * local), set `VITE_API_URL` in `.env` or in the deployment environment
 * — do not edit this constant per-environment.
 */
export const DEFAULT_API_URL = 'https://api.getcardbase.com';

export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? DEFAULT_API_URL,
  devConsole: import.meta.env.VITE_DEV_CONSOLE === 'true' || import.meta.env.DEV,
  stripeKey: import.meta.env.VITE_STRIPE_KEY ?? '',
  stripeSecretKey: import.meta.env.VITE_STRIPE_SECRET_KEY ?? '',
} as const;
